export const buildHandleEnterKeyPress = onClick => e => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    onClick();
  }
};
